import { useCallback } from 'react';
import { RoiId } from '~/domain/changes/ids';
import { useRoiCommands } from '~/hooks/domain/useRoiCommands';

/** Renames the structure `roiId` names, through the projection's ROI commands. */
export default function useRoiRename(roiId: RoiId): (newName: string) => void {
    const { rename } = useRoiCommands();
    return useCallback(
        (newName: string) => rename(roiId, newName),
        [roiId, rename]
    );
}
